import { WarningCircle } from "@phosphor-icons/react";

/**
 * Simple confirm modal. Pass { open, title, message, confirmLabel, tone, onConfirm, onCancel }.
 * tone = danger | warning | primary — drives the confirm button color.
 */
export default function ConfirmModal({ open, title, message, confirmLabel = "Confirmar", cancelLabel = "Cancelar", tone = "primary", onConfirm, onCancel, loading = false }) {
  if (!open) return null;
  const toneCls = {
    danger: "bg-rose-600 hover:bg-rose-700",
    warning: "bg-amber-600 hover:bg-amber-700",
    primary: "bg-slate-900 hover:bg-slate-800",
  }[tone] || "bg-slate-900 hover:bg-slate-800";

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 z-[60] flex items-center justify-center p-4"
      onClick={onCancel}
      data-testid="confirm-modal-backdrop"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-md border border-slate-200 w-full max-w-md p-6 space-y-4"
        data-testid="confirm-modal"
      >
        <div className="flex items-start gap-3">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${tone === "danger" ? "bg-rose-50 text-rose-600" : tone === "warning" ? "bg-amber-50 text-amber-600" : "bg-slate-100 text-slate-700"}`}>
            <WarningCircle size={20} weight="fill" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading text-base font-semibold text-slate-900 tracking-tight">{title}</h3>
            {message && <p className="text-sm text-slate-600 mt-1 leading-relaxed break-words">{message}</p>}
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            data-testid="confirm-cancel-btn"
            className="inline-flex items-center px-3.5 py-1.5 rounded-full border border-slate-200 bg-white hover:bg-slate-50 hover:border-slate-300 transition-colors text-[12px] font-medium text-slate-700 disabled:opacity-60"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-ok-btn"
            className={`inline-flex items-center rounded-full px-4 py-1.5 text-[12px] font-medium text-white shadow-sm transition-colors disabled:opacity-60 ${toneCls}`}
          >
            {loading ? "Aguarde…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
